import type {ILabel} from '../../../../types'

export default {
    productsTabTitle: <ILabel>{
        de: 'Aktuelle Show und nächste Aktionen',
        en: 'Current show and next shows',
        es: 'Programación actual y próximas ofertas',
        fr: 'Offres en cours et à venir',
        nl: 'Huidige show en volgende shows',
        it: 'Mostra attuali e prossimi articoli in vendita',
    }
}